import axios from "@/utils/axios";

export const getNotifications = async (limit = 10) => {
  const response = await axios.get("/notifications", { params: { limit } });
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await axios.patch(`/notifications/${id}/read`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await axios.patch("/notifications/read-all");
  return response.data;
};

export const dismissAllNotifications = async () => {
  const response = await axios.patch("/notifications/dismiss-all");
  return response.data;
};
